import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative mt-16 md:mt-24 border-t border-background-300/50 overflow-hidden">
      <div className="absolute inset-0 bg-background-100" />
      <div className="absolute inset-0 bg-gradient-to-br from-primary-950/60 via-background-100 to-secondary-950/40" />

      <div className="relative w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">
                亚洲视频一区
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              免费高清影视在线播放平台，汇聚电影、电视剧与综艺节目等丰富内容，为影视爱好者提供流畅、清晰的在线浏览与观看体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-mail-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-700 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-global-line" />
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4 tracking-wide">
              内容导航
            </h4>
            <ul className="flex flex-col gap-3 text-sm">
              {[
                { label: "首页", to: "/" },
                { label: "电影频道", to: "/category/movie" },
                { label: "电视剧频道", to: "/category/tv" },
                { label: "综艺频道", to: "/category/variety" },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4 tracking-wide">
              帮助与支持
            </h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  搜索影视
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-600 hover:text-primary-500 transition-colors"
                >
                  版权声明
                </Link>
              </li>
              <li className="text-foreground-600">联系邮箱：support@yazhoushipin1.com</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600 text-center sm:text-left">
            © 2024 亚洲视频一区 · 本站所有影视内容均为演示数据，仅供界面展示与功能演示。
          </p>
          <p className="text-xs text-foreground-600 text-center sm:text-right">
            本站不提供任何真实视频存储与播放服务
          </p>
        </div>
      </div>
    </footer>
  );
}